export default ({ request }) => ({
  factoryWorkshopListApi(data = {}) {
    return request({
      url: '/factory/workshop/list',
      method: 'post',
      data
    })
  },
  factoryWorkshopDetailApi(data = {}) {
    return request({
      url: '/factory/workshop/detail',
      method: 'post',
      data
    })
  },
  factoryWorkshopSaveApi(data = {}) {
    return request({
      url: '/factory/workshop/save',
      method: 'post',
      data
    })
  },
  factoryWorkshopDelApi(data = {}) {
    return request({
      url: '/factory/workshop/del',
      method: 'post',
      data
    })
  },
  factoryWorkshopProcessListApi(data = {}) {
    return request({
      url: '/factory/workshop/process/list',
      method: 'post',
      data
    })
  },
  factoryWorkshopProcessListPageApi(data = {}) {
    return request({
      url: '/factory/workshop/process/listPage',
      method: 'post',
      data
    })
  },
})
